<template>
  <Modal
    title="Kaufen Sie dieses Design"
    :is-visible="isModalVisible"
    :close-icon="closeIcon"
    @closed="onCloseBuythisDesignModal"
  >
    <template v-slot:body>
      <form
        :ref="purchaseDesignFormRef"
        :action="buyThisDesignUrl"
        class="text-center"
        method="get"
        data-abide
      >
        <img :src="designThumbnailImagePath" alt="Design thumbnail" />
        <p>
          Geben Sie den Betrag ein, den Sie für diese Design-Einreichung zahlen möchten (min. {{ currencyAbbreviation }}100):
        </p>
        <div class="row align-center">
          <div class="column small-12 medium-5">
            <div class="input-group">
              <span class="input-group-label">
                {{ currencyAbbreviation }}
              </span>
              <label :for="`amount-${_uid}`">
                <input
                  :id="`amount-${_uid}`"
                  v-model="purchaseAmount"
                  class="input-group-field"
                  type="number"
                  name="amount"
                  :min="minPurchaseAmount"
                  required
                />
              </label>
              <span class="input-group-label">.00</span>
            </div>
          </div>
          <div v-if="!isPurchaseAmountDefined" class="column small-12">
            <span class="u-block form-error">
              Bitte geben Sie einen Kaufbetrag ein
            </span>
          </div>
          <div
            v-if="isPurchaseAmountDefined && !isPurchaseAmountOverMinimum"
            class="column small-12"
          >
            <span class="u-block form-error">
              Bitte geben Sie einen Mindestbetrag von {{ currencyAbbreviation }}100 ein
            </span>
          </div>
        </div>
        <p>Nach der Zahlung werden Sie die Rechte zu diesem Design besitzen.</p>
      </form>
    </template>
    <template v-slot:footer>
      <div class="row align-center">
        <div class="column shrink">
          <button
            class="button tiny mbn"
            :disabled="isFormDisabled"
            @click="onClickPurchaseDesign"
          >
            Zur sicheren Zahlung fortfahren
          </button>
        </div>
        <button
          type="button"
          class="button secondary tiny hollow"
          data-close
          @click="onCancelBuythisDesignModal"
        >
          Stornieren
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal/Modal.vue';

export default {
  components: {
    Modal,
  },
  props: {
    buyThisDesignUrl: {
      type: String,
      default: undefined,
    },
    designThumbnailImagePath: {
      type: String,
      default: undefined,
    },
    currencyAbbreviation: {
      type: String,
      required: true,
    },
    closeIcon: {
      type: String,
      default: undefined,
    },
    buttonClass: {
      type: String,
      default: undefined,
    },
    isModalVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      purchaseDesignFormRef: 'js-purchase-design-form',
      purchaseAmount: 100,
      minPurchaseAmount: 100,
    };
  },
  computed: {
    purchaseAmountInt() {
      return parseInt(this.purchaseAmount, 10);
    },
    isPurchaseAmountDefined() {
      return !!this.purchaseAmountInt;
    },
    isPurchaseAmountOverMinimum() {
      return this.purchaseAmountInt >= this.minPurchaseAmount;
    },
    isFormDisabled() {
      return !(
        this.isPurchaseAmountDefined && this.isPurchaseAmountOverMinimum
      );
    },
  },
  methods: {
    onClickPurchaseDesign() {
      if (!this.isFormDisabled) {
        this.$refs[this.purchaseDesignFormRef].submit();
      }
      this.$emit('modal-closed');
    },
    onCloseBuythisDesignModal(event) {
      if (event) {
        event.preventDefault();
      }
      this.$emit('modal-closed');
    },
    onCancelBuythisDesignModal(event) {
      if (event) {
        event.preventDefault();
      }
      this.$emit('modal-closed');
      this.$emit('modal-not-visible');
    },
  },
};
</script>
